import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../Common/Layout/CustomAlerts";
import LayoutHeader from "../Common/Layout/Header";
import LayoutSidebar from "../Common/Layout/Sidebar";
import { Eye, EyeOff } from "lucide-react";
const initialChangePasswordValues = {
  userId: localStorage.getItem("userId"),
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};
export default function ChangePassword() {
  const [values, setValues] = useState(initialChangePasswordValues);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
      "Content-Type": "application/json",
    },
  };
  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const validate = () => {
    let temp = {};
    temp.oldPassword = values.oldPassword === "" ? false : true;
    temp.newPassword = values.newPassword === "" ? false : true;
    temp.confirmPassword = values.confirmPassword === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (values.newPassword === values.confirmPassword) {
        changePassword();
        clearForm();
      } else {
        handleError("New and Confirm Passwords should be same");
      }
    }
  };
  const changePassword = (changePasswordData) => {
    applicationAPI()
      .postchangepassword(changePasswordData)
      .then((res) => {
        if (res.data.statusCode === 200) {
          handleSuccess(res.data.data);
          clearForm();
        } else {
          handleError(res.data.data);
        }
      });
  };
  const applicationAPI = () => {
    return {
      postchangepassword: () =>
        axios.post(
          config.APIACTIVATEURL +
            config.CHANGEPASSWORD +
            "?UserId=" +
            localStorage.getItem("userId") +
            "&OldPassword=" +
            values.oldPassword +
            "&NewPassword=" +
            values.newPassword,
          { ...headerconfig }
        ),
    };
  };
  const comparePassword = (newPassword, confirmPassword) => {
    if (newPassword !== confirmPassword) {
      handleError("New and Confirm Passwords should be same");
      return false;
    }
    return true;
  };
  const clearForm = () => {
    setValues(initialChangePasswordValues);
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSidebar></LayoutSidebar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Change Password</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3 position-relative">
                      <label htmlFor="oldPassword" className="form-label">
                        Old Password
                      </label>
                      <input
                        type={showPassword.oldPassword ? "text" : "password"}
                        value={values.oldPassword}
                        name="oldPassword"
                        onChange={handleInputChange}
                        className={
                          "form-control" + applyErrorClass("oldPassword")
                        }
                        placeholder="Please Enter Old Password"
                      />
                      <span
                        onClick={() => togglePasswordVisibility("oldPassword")}
                        style={{
                          position: "absolute",
                          top: "38px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {showPassword.oldPassword ? (
                          <EyeOff size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </span>
                      {errors.oldPassword === false && (
                        <div className="validationerror">
                          Please enter old password
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="mb-3 position-relative">
                      <label htmlFor="newPassword" className="form-label">
                        New Password
                      </label>
                      <input
                        type={showPassword.newPassword ? "text" : "password"}
                        value={values.newPassword}
                        name="newPassword"
                        onChange={handleInputChange}
                        className={
                          "form-control" + applyErrorClass("newPassword")
                        }
                        placeholder=" Please Enter New Password"
                      />
                      <span
                        onClick={() => togglePasswordVisibility("newPassword")}
                        style={{
                          position: "absolute",
                          top: "38px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {showPassword.newPassword ? (
                          <EyeOff size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </span>
                      {errors.newPassword === false && (
                        <div className="validationerror">
                          Please enter new password
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3 position-relative">
                      <label htmlFor="confirmPassword" className="form-label">
                        Confirm Password
                      </label>
                      <input
                        type={
                          showPassword.confirmPassword ? "text" : "password"
                        }
                        value={values.confirmPassword}
                        name="confirmPassword"
                        onChange={handleInputChange}
                        className={
                          "form-control" + applyErrorClass("confirmPassword")
                        }
                        placeholder=" Please Confirm Password"
                      />
                      <span
                        onClick={() =>
                          togglePasswordVisibility("confirmPassword")
                        }
                        style={{
                          position: "absolute",
                          top: "38px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                      >
                        {showPassword.confirmPassword ? (
                          <EyeOff size={18} />
                        ) : (
                          <Eye size={18} />
                        )}
                      </span>
                      {errors.confirmPassword === false && (
                        <div className="validationerror">
                          Please confirm password
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      <button type="submit" className="btn btn-primary">
                        Change Password
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
